import * as Util from "./_utilites"
import * as d3_arrays from "d3-array";

/**
 * computes Unique Values within an Array. 
 * @param {[]} values 
 * @param {boolean} sort - optional 
 * @returns {array} of Unique Values
 */

export function getSortedVals(values)
{
  return values.sort(Util.naturalSort);
}

export function getUniqueVals(values, sort= true)
{
  var uniqueVals = values.filter((v, i, a) => a.indexOf(v) === i);
  if(sort) return uniqueVals.sort(Util.naturalSort);
  else return uniqueVals;
}

// for strings and numbers - confirm
export function getMin(values)
{
  return d3_arrays.min(values);
}

//for numbers and string - confirm
export function getMax(values)
{
  return d3_arrays.max(values);
}

// gets the median of numerical values
export function getMedian(values)
{
  return d3_arrays.median(values);
}

// gets the mean of numerical values
export function getMean(values)
{
  return d3_arrays.mean(values);
}

// gets the sum of numerical values
export function getSum(values)
{
  return d3_arrays.sum(values);
}

// for numerical values
export function getRange(values)
{
  // Convert values to an array of numbers
  const numericValues = Array.from(values, value => Number(value));

  // Check for NaN values
  const validValues = numericValues.filter(value => !isNaN(value));

  let range = [];
  range.push(d3_arrays.min(validValues));
  range.push(d3_arrays.max(validValues));
  
  return range;
}

//get value with specified number of digits
export function getSigFig(value,digits){
  return Number.parseFloat(value).toFixed(digits);
}

//get array with each value with specified number of digits
export function getSigFigs(values,digits){
  sigFigArray = values.map((value) => (Number.parseFloat(value).toFixed(digits)));
  return sigFigArray
}

//checks value if it's a number and if its an integer and rounds if needed
//accepts format of number and number strings eg.'1.0'
export function roundIfNeeded(value, digits){
  if(value != "" && !isNaN(value)) {
    value =  Number.parseFloat(value);
  }
  if(Number.isFinite(value) & !Number.isInteger(value)){
    value = +Number.parseFloat(value).toFixed(digits);
    return value;
  } else{
   return value;
  }
}

//takes an array of mixed values and rounds them if they are numbers that require it. 
//Will not add decimal to integers
export function roundArrayIfNeeded(array, digits){
  return array.map(val => roundIfNeeded(val, digits))
}

/**
 * implements d3.intersection().
 * @param {[[String]]} Sets an array of sets to intersect 
 * @returns Returns a new InternSet containing every (distinct) value
 */
export function getIntersection(Sets){
  return Array.from(d3_arrays.intersection(...Sets));
}